import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'lens_id' },
  { name: 'created' },
  { name: 'doc_number' },
  { name: 'docdb_id' },
  { name: 'jurisdiction' },
  { name: 'kind' },
  { name: 'lang' },
  { name: 'date_published' },
  { name: 'year_published' },
  { name: 'publication_type' },
  { name: 'earliest_priority_claim_date' },
  { name: 'application_reference.jurisdiction' },
  { name: 'application_reference.date' },
  { name: 'application_reference.doc_number' },
  { name: 'application_reference.kind' },
  { name: 'priority_claim.jurisdiction' },
  { name: 'priority_claim.date' },
  { name: 'priority_claim.doc_number' },
  { name: 'priority_claim.kind' },
  { name: 'abstract' },
  { name: 'claim' },
  { name: 'description' },
  { name: 'title' },
  { name: 'family.extended.member.document_id.jurisdiction' },
  { name: 'family.extended.member.document_id.date' },
  { name: 'family.extended.member.document_id.doc_number' },
  { name: 'family.extended.member.document_id.kind' },
  { name: 'family.extended.member.lens_id' },
  { name: 'family.extended.size' },
  { name: 'family.simple.member.document_id.jurisdiction' },
  { name: 'family.simple.member.document_id.date' },
  { name: 'family.simple.member.document_id.doc_number' },
  { name: 'family.simple.member.document_id.kind' },
  { name: 'family.simple.member.lens_id' },
  { name: 'family.simple.size' },
  { name: 'applicant.address' },
  { name: 'applicant.name' },
  { name: 'applicant.name.exact' },
  { name: 'applicant.residence' },
  { name: 'applicant_count' },
  { name: 'inventor.address' },
  { name: 'inventor.name' },
  { name: 'inventor.name.exact' },
  { name: 'inventor.residence' },
  { name: 'inventor_count' },
  { name: 'owner_all.address' },
  { name: 'owner_all.country' },
  { name: 'owner_all.execution_date' },
  { name: 'owner_all.name' },
  { name: 'owner_all.name.exact' },
  { name: 'owner_all.recorded_date' },
  { name: 'owner_all_count' },
  { name: 'examiner.name' },
  { name: 'examiner.name.exact' },
  { name: 'examiner.department' },
  { name: 'primary_examiner.name' },
  { name: 'primary_examiner.name.exact' },
  { name: 'primary_examiner.department' },
  { name: 'assistant_examiner.name' },
  { name: 'assistant_examiner.name' },
  { name: 'cited_by.patent.document_id.jurisdiction' },
  { name: 'cited_by.patent.document_id.doc_number' },
  { name: 'cited_by.patent.document_id.kind' },
  { name: 'cited_by.patent.lens_id' },
  { name: 'cited_by.patent_count' },
  { name: 'reference_cited.npl.external_id' },
  { name: 'reference_cited.npl.lens_id' },
  { name: 'reference_cited.npl.text' },
  { name: 'reference_cited.npl_count' },
  { name: 'reference_cited.npl_resolved_count' },
  { name: 'reference_cited.patent.lens_id' },
  { name: 'reference_cited.patent.document_id.jurisdiction' },
  { name: 'reference_cited.patent.document_id.date' },
  { name: 'reference_cited.patent.document_id.doc_number' },
  { name: 'reference_cited.patent.document_id.kind' },
  { name: 'reference_cited.patent_count' },
  { name: 'legal_status.application_expiry_date' },
  { name: 'legal_status.anticipated_term_date' },
  { name: 'legal_status.discontinuation_date' },
  { name: 'legal_status.grant_date' },
  { name: 'legal_status.granted' },
  { name: 'legal_status.has_disclaimer' },
  { name: 'legal_status.patent_status' },
  { name: 'legal_status.has_spc' },
  { name: 'agent.address' },
  { name: 'agent.country' },
  { name: 'agent.name' },
  { name: 'agent.name.exact' },
  { name: 'agent_count' },
  { name: 'class_cpc.symbol' },
  { name: 'class_ipcr.symbol' },
  { name: 'class_national.symbol' },
  { name: 'sequence.count' },
  { name: 'sequence.data_source' },
  { name: 'sequence.document_location' },
  { name: 'sequence.length_bucket' },
  { name: 'sequence.organism.tax_id' },
  { name: 'sequence.type' },
  { name: 'sequence.organism.name' },
  { name: 'sequence.organism.name.exact' },
  { name: 'reference_cited.npl_resolved_count' }
]

const defaultSyntaxGuideUrl = 'https://support.lens.org/knowledge-base/search-syntax/'

class LensPatentEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('Lens Patents')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://www.lens.org/lens/search/patent/list?q=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default LensPatentEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/LensPatentEngine.js